import focusTrap from './focus-trap';
import { show as showOverlay, hide as hideOverlay, create as createOverlay } from './overlay';

export default class Popup {
  constructor(element, overlay = true) {
    if (typeof element === 'string' || element instanceof String) {
      this.container = document.querySelector(element);
    } else {
      this.container = element;
    }

    this.overlay = overlay;

    this.classes = {
      active: 'popup--active',
    };

    this.closeBtns = [...element.querySelectorAll('[data-close-popup]')];
    this.focusTrap = focusTrap(this.container);

    this.clickEvent = this.clickEvent.bind(this);
    this.keydownEvent = this.keydownEvent.bind(this);
    this.addEventListeners = this.addEventListeners.bind(this);

    if (this.overlay) {
      createOverlay();
    }
  }

  addEventListeners() {
    document.addEventListener('click', this.clickEvent);
    document.addEventListener('keydown', this.keydownEvent);
    this.focusTrap.enable();
  }

  removeEventListeners() {
    document.removeEventListener('click', this.clickEvent);
    document.removeEventListener('keydown', this.keydownEvent);
    this.focusTrap.disable();
  }

  clickEvent(event) {
    const anyCloseBtnsContainsTarget = () => {
      let any = false;
      this.closeBtns.forEach((btn) => {
        if (btn.contains(event.target)) {
          any = true;
        }
      });

      return any;
    };

    if (!this.container.contains(event.target) || anyCloseBtnsContainsTarget()) {
      event.stopPropagation();
      this.close();
    }
  }

  keydownEvent(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  toggle() {
    if (this.container.classList.contains(this.classes.active)) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.container.setAttribute('aria-hidden', 'false');
    this.container.classList.add(this.classes.active);
    document.documentElement.style.overflow = 'hidden';

    if (this.overlay) showOverlay();

    setTimeout(this.addEventListeners, 1);
  }

  close(keepBgLocked = false) {
    this.container.setAttribute('aria-hidden', 'true');
    this.container.classList.remove(this.classes.active);

    if (!keepBgLocked) {
      document.documentElement.style.overflow = 'initial';
    }

    if (this.overlay) hideOverlay();

    this.container.dispatchEvent(new Event('popup:close'));
    this.removeEventListeners();
  }
}
